class HeroSlider {
  constructor(el) {
    this.el = el;
    this.track = el.querySelector(".hero-slider__track");
    this.slides = Array.from(el.querySelectorAll(".hero-slide"));
    this.dots = Array.from(el.querySelectorAll(".hero-slider__dot"));
    this.dotsNav = el.querySelector(".hero-slider__dots");

    this.autoplay = el.dataset.autoplay === "true";
    this.speed = parseInt(el.dataset.speed, 10) || 5000;

    this.current = 0;
    this.timer = null;
    this.transitioning = false;

    if (this.slides.length === 0) return;

    this.el.classList.add("hero-slider--no-transition");
    this._activate(0);
    requestAnimationFrame(() => {
      this.el.classList.remove("hero-slider--no-transition");
    });
    this._bindDots();
    this._bindHover();
    this._bindSwipe();

    if (this.autoplay && this.slides.length > 1) {
      this._startAutoplay();
    }
  }

  _activate(index, forcedDirection) {
    const prev = this.current;
    this.current = index;
    const direction = forcedDirection || (index > prev ? "forward" : "backward");

    this.el.dataset.direction = direction;

    // backward: place the incoming slide on the left before it slides in
    if (direction === "backward" && index !== prev) {
      const incoming = this.slides[index];
      incoming.style.transition = "none";
      incoming.style.transform = "translateX(-100%)";
      void incoming.offsetWidth;
      incoming.style.transition = "";
      incoming.style.transform = "";
    }

    // set is-prev before removing is-active so CSS can position it
    this.slides[prev].classList.add("is-prev");
    this.slides[prev].classList.remove("is-active");
    this.slides[index].classList.add("is-active");

    // clean up other slides
    this.slides.forEach((s, i) => {
      if (i !== index && i !== prev) {
        s.classList.remove("is-active", "is-prev");
      }
    });

    const durationMs = parseFloat(
      getComputedStyle(document.documentElement).getPropertyValue("--slide-duration")
    ) * 1000;

    setTimeout(() => {
      // Disable transition before removing is-prev to prevent visible repositioning
      this.slides[prev].style.transition = "none";
      this.slides[prev].classList.remove("is-prev");
      delete this.el.dataset.direction;
      this.transitioning = false;

      // Re-enable transition after two frames to ensure the style has been applied
      requestAnimationFrame(() => {
        requestAnimationFrame(() => {
          this.slides[prev].style.transition = "";
        });
      });
    }, durationMs);

    this.dots.forEach((d, i) => d.classList.toggle("is-active", i === index));
  }

  _goTo(index, direction) {
    if (this.transitioning || index === this.current) return;
    this.transitioning = true;
    this._activate(index, direction);
  }

  _next() {
    const next = (this.current + 1) % this.slides.length;
    this._goTo(next);
  }

  _startAutoplay() {
    this.timer = setInterval(() => this._next(), this.speed);
  }

  _stopAutoplay() {
    clearInterval(this.timer);
  }

  _bindDots() {
    this.dots.forEach((dot, i) => {
      dot.addEventListener("click", () => {
        this._stopAutoplay();
        this._goTo(i);
        if (this.autoplay) this._startAutoplay();
      });
    });
  }

  _bindSwipe() {
    if (this.slides.length < 2) return;

    const threshold = 50;
    let startX = 0;
    let startY = 0;
    let tracking = false;

    this.track.addEventListener(
      "touchstart",
      (e) => {
        if (e.touches.length !== 1) return;
        startX = e.touches[0].clientX;
        startY = e.touches[0].clientY;
        tracking = true;
      },
      { passive: true }
    );

    this.track.addEventListener(
      "touchend",
      (e) => {
        if (!tracking) return;
        tracking = false;

        const dx = e.changedTouches[0].clientX - startX;
        const dy = e.changedTouches[0].clientY - startY;
        if (Math.abs(dx) < threshold || Math.abs(dx) < Math.abs(dy)) return;

        const count = this.slides.length;
        this._stopAutoplay();
        if (dx < 0) {
          this._goTo((this.current + 1) % count, "forward");
        } else {
          this._goTo((this.current - 1 + count) % count, "backward");
        }
        if (this.autoplay) this._startAutoplay();
      },
      { passive: true }
    );

    this.track.addEventListener("touchcancel", () => (tracking = false), { passive: true });
  }

  _bindHover() {
    this.el.addEventListener("mouseenter", () => {
      if (this.autoplay) this._stopAutoplay();
    });
    this.el.addEventListener("mouseleave", () => {
      if (this.autoplay) this._startAutoplay();
    });
  }
}

document.querySelectorAll(".hero-slider").forEach((el) => new HeroSlider(el));
